import type { ReactNode } from "react";
import {
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";

import { compactTableSx } from "../shared/ExternalRegisterSettingsUi";

export const panelSx = {
  borderRadius: 1,
  boxShadow: "none",
} as const;

export const fieldGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    md: "repeat(2, minmax(0, 1fr))",
  },
  gap: 1.25,
} as const;

export const compactFieldSx = {
  "& .MuiInputBase-root": {
    minHeight: 40,
  },
  "& .MuiInputBase-input": {
    py: 1,
  },
} as const;

export const compactSelectSx = {
  "& .MuiInputBase-root": {
    minHeight: 40,
  },
  "& .MuiSelect-select": {
    py: 1,
  },
} as const;

export const compactOutlinedButtonSx = {
  minWidth: "auto",
  height: 26,
  px: 0.45,
  py: 0,
  fontSize: "0.68rem",
  lineHeight: 1.25,
  textTransform: "none",
  borderRadius: 1,
} as const;

export const compactAdminTableSx = {
  ...compactTableSx,
  borderCollapse: "separate",
  borderSpacing: 0,
  tableLayout: "fixed",
  "& th": {
    ...compactTableSx["& th"],
    backgroundColor: "background.paper",
    boxShadow: "inset 0 -1px 0 rgba(15, 23, 42, 0.16)",
    position: "sticky",
    top: 0,
    py: 0.55,
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    zIndex: 3,
  },
  "& td": {
    ...compactTableSx["& td"],
    py: 0.45,
    verticalAlign: "middle",
  },
  "& .MuiChip-root": {
    maxWidth: "100%",
  },
  "& .MuiChip-label": {
    px: 0.75,
    overflow: "visible",
    textOverflow: "clip",
  },
} as const;

export const multilineFieldSx = {
  gridColumn: { md: "1 / -1" },
  "& .MuiInputBase-root": {
    alignItems: "flex-start",
  },
} as const;

export const fieldLabel = (label: string, description: string): ReactNode => (
  <Tooltip title={description} arrow placement="top">
    <span>{label}</span>
  </Tooltip>
);

export const ReadOnlySettingValue = ({ label, value }: { label: string; value: string | number }) => (
  <Paper variant="outlined" sx={{ p: 1, borderRadius: 1, backgroundColor: "grey.50" }}>
    <Typography variant="caption" color="text.secondary" sx={{ display: "block", fontWeight: 700, textTransform: "uppercase" }}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Paper>
);
